import { render, staticRenderFns } from "./brightPoints.vue?vue&type=template&id=4dbc1741&scoped=true&"
import script from "./brightPoints.vue?vue&type=script&lang=js&"
export * from "./brightPoints.vue?vue&type=script&lang=js&"
import style0 from "./brightPoints.vue?vue&type=style&index=0&id=4dbc1741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc1741",
  null
  
)

export default component.exports